import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'https://be.bietesrunter.store';

const api = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const raw = localStorage.getItem('Biet Es Runter_user');
  if (raw) {
    try {
      const user = JSON.parse(raw);
      if (user?.token) config.headers.Authorization = `Bearer ${user.token}`;
    } catch {}
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('Biet Es Runter_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
